import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {DownloadSnackbarData} from "./download-snackbar-data";
import {Subscription} from "rxjs";
import {MatSnackBarActions, MatSnackBarRef} from "@angular/material/snack-bar";
import {SnackBarService} from "../snack-bar-service";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {DecimalPipe} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {AssetStateService} from "../../assets/asset.state.service";
import {AssetAction} from "../../dam-header/action-bar/asset-action";

@Component({
  selector: 'app-download-snackbar',
  imports: [
    TranslatePipe,
    DecimalPipe,
    MatButton,
    MatSnackBarActions
  ],
  templateUrl: './download-snackbar.component.html',
  styleUrl: './download-snackbar.component.scss'
})
export class DownloadSnackbarComponent implements OnInit, OnDestroy {
  data: DownloadSnackbarData | undefined;
  dataSub: Subscription | undefined;
  allowedLocales: string[] = ['en-GB', 'en-US', 'de-DE'];
  locale: string = 'en-GB';
  constructor(public ref: MatSnackBarRef<DownloadSnackbarComponent>,
              private snackbarService: SnackBarService,
              private renderer: Renderer2,
              private translate: TranslateService,
              private assetStateService: AssetStateService) {
  }
  ngOnInit() {
    this.dataSub = this.snackbarService.getDownloadSnackbarData().subscribe( res => {
      this.data = res;
    })
    if (this.translate.defaultLang) {
      if (this.isAllowLocale(this.translate.defaultLang)) {
        this.locale = this.translate.defaultLang;
      } else {
          this.locale = 'en-Gb'
      }
    }
  }
  download() {
    if (this.data) {
      const link = this.renderer.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', this.data.link);
      link.setAttribute('download', this.data.fileName);
      link.click();
      link.remove();
      this.assetStateService.assetAction = AssetAction.selectNone;
      this.ref.dismiss();
    }
  }
  isAllowLocale(value: any): boolean {
    for (const loc of this.allowedLocales) {
      if (loc === value) {
        return true;
      }
    }
    return false;
  }

  ngOnDestroy() {
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }
  }
}
